import {
  RejectResponseType,
  CommonErrorPayloadFormatType
} from 'types/errorResponse'

export const ERROR = 'ERROR'
export const CLEAR_ERROR = 'CLEAR_ERROR'

export type ErrorActionType = {
  error: CommonErrorPayloadFormatType
  type: typeof ERROR
}

export type ActionType = ErrorActionType

export const error = (error: CommonErrorPayloadFormatType) => ({
  type: ERROR,
  error
})

export const clearError = () => ({
  type: CLEAR_ERROR
})

export const toCommonErrorPayloadFormat = (
  action: {type: string},
  error: RejectResponseType
): CommonErrorPayloadFormatType => ({
  originalErrorAction: action?.type,
  errorResponse: error?.data,
  statusCode: error?.status,
  value: {
    statusCode: error?.status,
    params: error?.config?.params,
    headers: error?.config?.headers,
    url: error?.config?.url,
    method: error?.config?.method,
    errorResponse: error?.data
  }
})
